import {createAsyncThunk} from '@reduxjs/toolkit';
import targetPlatformApi from 'common/src/modules/targetPlatform/targetPlatform.api';
import videoSettingsApi from 'common/src/modules/videoSettings/videoSettings.api';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';

export const initializeTargetPlatforms = createAsyncThunk(
  `${BreadcrumbName.TargetPlatforms}/initialize`,
  async (_, {rejectWithValue}) => {
    try {
      const [platforms, videoSettings] = await Promise.all([
        targetPlatformApi.fetchTargetPlatformsWithDSPs(),
        videoSettingsApi.fetchVideoSettings(),
      ]);

      return {platforms, videoSettings};
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);
